/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'repository': {
    width: 16,
    height: 16,
    viewBox: '0 0 19.7 22.6',
    data: '<path pid="0" d="M18.7 2.7c-.6 0-1 .4-1 1v16.7c0 .1-.1.2-.2.2H3.6c-.1 0-.2-.1-.2-.3v-2.6h10.9c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2H2C.9 0 0 .9 0 2v13.8c0 .9.6 1.6 1.4 1.9v2.6c0 1.2.9 2.3 2.2 2.3h13.9c1.2 0 2.2-1.1 2.2-2.3V3.7c0-.6-.5-1-1-1zM3.5 4.3h8.2v1H3.5v-1zm0 3.6h8.2v1H3.5v-1z" _fill="#757e8d"/>'
  }
})
